import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';

import { AppFilterByPipe } from 'src/shared/pipes/appFilterBy.pipe';
import { AppOrderByPipe } from 'src/shared/pipes/appOrderBy.pipe';
import { CapitalizePipe } from 'src/shared/pipes/capitalize.pipe';
import { CustomFormatPipe } from 'src/shared/pipes/customFormat.pipe';
import { FilterByPipe } from 'src/shared/pipes/filterBy.pipe';
import { OrderByPipe } from 'src/shared/pipes/orderBy.pipe';
import { OrderByMonitorPipe } from 'src/shared/pipes/orderByMonitor.pipe';
import { OrderTechrulePipe } from 'src/shared/pipes/orderByTechrules.pipe';
import { OrderRankingPipe } from 'src/shared/pipes/orderRanking.pipe';
import { SearchContractsPipe } from 'src/shared/pipes/searchContracts.pipe';
import { SearchFilterPipe } from 'src/shared/pipes/searchFilter.pipe';
import { SearchFundsPipe } from 'src/shared/pipes/searchFunds.pipe';

@NgModule({
  imports: [CommonModule],

  declarations: [
    OrderByPipe,
    CustomFormatPipe,
    FilterByPipe,
    OrderByMonitorPipe,
    CapitalizePipe,
    AppFilterByPipe,
    AppOrderByPipe,
    SearchContractsPipe,
    SearchFilterPipe,
    SearchFundsPipe,
    OrderRankingPipe,
    OrderTechrulePipe,
  ],

  exports: [
    OrderByPipe,
    CustomFormatPipe,
    FilterByPipe,
    OrderByMonitorPipe,
    CapitalizePipe,
    AppFilterByPipe,
    SearchContractsPipe,
    AppOrderByPipe,
    SearchFilterPipe,
    SearchFundsPipe,
    OrderRankingPipe,
    OrderTechrulePipe,
  ],
})
export class PipesModule {}
